// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/ddt/:id',
    requestBody: null,
    response: '{"success":true,"data":{"id":"number","societaId":"number","tipo":"VENDITA|CANTIERE","stato":"BOZZA|EMESSO|ANNULLATO","numero":"string|null","dataEmissione":"string|null","dataTrasporto":"string|null","clienteRagioneSociale":"string|null","destinazioneDescrizione":"string|null","destinazioneIndirizzo":"string|null","destinazioneCap":"string|null","destinazioneCitta":"string|null","destinazioneProvincia":"string|null","causaleTrasporto":"string|null","aspettoBeni":"string|null","colli":"number|null","pesoKg":"number|null","porto":"string|null","vettore":"string|null","annotazioni":"string|null","movimentoMagazzinoId":"number|null","tipoDocumentoId":"number|null","tipoDocumento":{"id":"number","codice":"string","nome":"string","causaleMovimento":{"codice":"string","descrizione":"string","tipo":"string"}},"ordine":{"id":"number","numero":"string","flussoCommerciale":"string"},"commessa":{"id":"number","numero":"string","descrizione":"string","clienteRagioneSociale":"string"},"movimentoMagazzino":{"id":"number","numero":"number","anno":"number","stato":"string"},"fatturaCollegata":{"id":"number","numero":"string|null","stato":"string"},"createdBy":{"id":"number","nome":"string","cognome":"string"},"annullatoDa":{"id":"number","nome":"string","cognome":"string"},"righe":[{"id":"number","ordinePos":"number","rigaOrdineId":"number|null","componenteId":"number|null","rigaDistintaId":"number|null","articoloId":"number|null","descrizione":"string","umVendita":"string|null","quantita":"number","note":"string|null","articolo":{"id":"number","codice":"string","descrizioneBase":"string"},"rigaDistinta":{"id":"number","distintaId":"number"}}],"logs":[{"id":"number","utenteName":"string","azione":"string","dettaglio":"string","createdAt":"string"}]}}'
  },
  {
    method: 'GET',
    endpoint: '/api/tipi-documento?societaId=&famiglia=&soloAttivi=true',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","codice":"string","nome":"string"}]}'
  },
  {
    method: 'POST',
    endpoint: '/api/ddt/:id/emetti',
    requestBody: null,
    response: '{"success":true,"data":{"stato":"EMESSO","numero":"string","dataEmissione":"string","movimentoMagazzinoId":"number|null","magazzinoWarning":"string|null"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/ddt/:id/annulla',
    requestBody: '{"motivo":"string?"}',
    response: '{"success":true,"data":{"stato":"ANNULLATO"}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/ddt/:id',
    requestBody: null,
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/fatture/da-ddt',
    requestBody: '{"ddtId":"number"}',
    response: '{"success":true,"data":{"id":"number"}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/ddt/:id',
    requestBody: '{"tipoDocumentoId":"number|null","dataTrasporto":"string|null","destinazioneDescrizione":"string|null","destinazioneIndirizzo":"string|null","destinazioneCap":"string|null","destinazioneCitta":"string|null","destinazioneProvincia":"string|null","causaleTrasporto":"string|null","aspettoBeni":"string|null","colli":"number|null","pesoKg":"number|null","porto":"string|null","vettore":"string|null","annotazioni":"string|null"}',
    response: '{"success":true}'
  },
  {
    method: 'PUT',
    endpoint: '/api/ddt/:id',
    requestBody: '{"righe":[{"rigaOrdineId":"number|null","componenteId":"number|null","rigaDistintaId":"number|null","articoloId":"number|null","descrizione":"string","umVendita":"string|null","quantita":"number","note":"string|null"}]}',
    response: '{"success":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
